import { KeyboardEventRepeater } from "./utils/KeyboardEventRepeater";
import { HardwareLogger } from "./utils/logger";

import { type LabelPrinter } from "./label-printer/LabelPrinter";
import { PrintApiLabelPrinterService } from "./label-printer/print-api/PrintApiLabelPrinterService";
import { type ReceiptPrinter } from "./receipt-printer/ReceiptPrinter";
import { PrintApiReceiptPrinterService } from "./receipt-printer/print-api/PrintApiReceiptPrinterService";
import type { Scale } from "./scale/Scale";
import type { Scanner } from "./scanner/Scanner";
import type { Peripheral } from "./shared/Peripheral";
import type { PrintApiServiceConfig } from "./shared/print-api/types";
import { PeripheralServiceManager } from "./shared/PeripheralServiceManager";
import { PeripheralServicePrinterManager } from "./shared/PeripheralServicePrinterManager";
import { PeripheralType } from "./shared/types";
import { PrintApiClient } from "./shared/print-api/PrintApiClient";

export const HardwareService = (() => {
  let printApiClient: PrintApiClient | undefined;
  let printApiConfig: PrintApiServiceConfig | undefined;

  return {
    get printApiClient(): PrintApiClient | undefined {
      if (printApiClient) {
        return printApiClient;
      }

      if (!printApiConfig) {
        return undefined;
      }

      printApiClient = PrintApiClient.getInstance(printApiConfig);
      return printApiClient;
    },
    setPrintApiConfig(config: PrintApiServiceConfig | null, types: { receipt: boolean, label: boolean} = { receipt: true, label: true }) {
      printApiConfig = config ? config : undefined;
      if (config) {
        if (types.label) {
          HardwareService.labelPrinter.register(new PrintApiLabelPrinterService(config));
        }
        if (types.receipt) {
          HardwareService.receiptPrinter.register(new PrintApiReceiptPrinterService(config));
        }
      } else {
        HardwareService.labelPrinter.unregisterServiceName('PrintApiLabelPrinterService');
        HardwareService.receiptPrinter.unregisterServiceName('PrintApiReceiptPrinterService');
      }
    },
    dispose: (): void => {
      HardwareService.labelPrinter.dispose();
      HardwareService.receiptPrinter.dispose();
      HardwareService.scale.dispose();
      HardwareService.scanner.dispose();
      KeyboardEventRepeater.disposeInstance();
    },
    managerByType: (type: PeripheralType): PeripheralServiceManager<Peripheral> => {
      switch (type) {
        case PeripheralType.labelPrinter:
          return HardwareService.labelPrinter;
        case PeripheralType.receiptPrinter:
          return HardwareService.receiptPrinter;
        case PeripheralType.scale:
          return HardwareService.scale;
        case PeripheralType.scanner:
          return HardwareService.scanner;
      }
    },
    labelPrinter: new PeripheralServicePrinterManager<LabelPrinter>(PeripheralType.labelPrinter),
    logger: new HardwareLogger(),
    receiptPrinter: new PeripheralServicePrinterManager<ReceiptPrinter>(PeripheralType.receiptPrinter),
    scale: new PeripheralServiceManager<Scale>(PeripheralType.scale),
    scanner: new PeripheralServiceManager<Scanner>(PeripheralType.scanner),
  };
})();
